export enum Mark {
  MARK_AS_YES = 'X',
}
